/*
 * Paid affiliate placement (300 x 250 creative inside the 300-wide sidebar column).
 * Clearly labelled as sponsored and marked rel="sponsored nofollow" per Google
 * and FTC guidance. Opened in a new tab so a visitor does not lose calculator work.
 */
const SPONSORED_HREF = 'https://hop.clickbank.net/?affiliate=dormercalc&vendor=shedplans'
const SPONSORED_IMG = 'https://myshedplans.com/images/banner/shed300x250.gif'

function SponsoredSlot() {
  return (
    <aside aria-label="Sponsored" className="my-8">
      <p className="mb-1 text-center text-[11px] font-semibold uppercase tracking-widest text-steel-400">
        Sponsored
      </p>
      <div className="flex min-h-[250px] w-full items-center justify-center overflow-hidden rounded-xl border border-steel-200 bg-white">
        <a
          href={SPONSORED_HREF}
          target="_blank"
          rel="sponsored nofollow noopener noreferrer"
          data-sponsored="shed-plans"
          className="block"
        >
          <img
            src={SPONSORED_IMG}
            alt="Shed plans banner: sponsored partner offer"
            width={300}
            height={250}
            loading="lazy"
            decoding="async"
            className="h-[250px] w-[300px] max-w-full"
          />
        </a>
      </div>
      <p className="mt-1.5 text-center text-[11px] leading-snug text-steel-400">
        Ad from a partner. We may earn a commission.
      </p>
    </aside>
  )
}

export default SponsoredSlot
